import React, { Component, createRef } from "react";
import TranslationFile from "../../Pages/15-Translation/locale/Translation_apps.json";
import { Button } from "primereact/button";

export default function NoAccess() {
  let userSelectedLanguage = localStorage.getItem("selectedLanguage");

  const redirectToHomePage = () => {
    window.location.assign("/#/annualreport");
  };

  return (
    <div>
      <center>
        <div className="no-access-div">
          <table>
            <tr>
              <td>
                <i
                  className="pi pi-times-circle"
                  style={{ color: "red", fontSize: "2rem" }}
                ></i>
              </td>
              <td>
                <label style={{ paddingLeft: "10px", color: "red" }}>
                  {
                    TranslationFile.IncomestateYearNoAccess[
                      userSelectedLanguage
                    ]
                  }
                </label>
              </td>
            </tr>
          </table>
          <Button onClick={() => redirectToHomePage()}>
            {TranslationFile.IncomestateYearGoToHome[userSelectedLanguage]}
          </Button>
        </div>
      </center>
    </div>
  );
}
